/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Import_ConfirmInputs */



/**
* | output |
* | --- |
* | "Import" |
*
* @param {Preset_Manager_Import_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_confirm = /** @type {((inputs?: Preset_Manager_Import_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("进口")
	if (locale === "ja") return /** @type {LocalizedString} */ ("輸入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar")
	return /** @type {LocalizedString} */ ("Import")
});